import React from 'react';
import { ArrowLeft, Shield } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function PrivacyPolicyPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-8">
      <div className="mx-auto max-w-4xl bg-white rounded-xl shadow-sm overflow-hidden">
        <div className="p-6 md:p-8 border-b border-gray-100 flex items-center gap-4">
          <button
            onClick={() => navigate(-1)}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
          >
            <ArrowLeft className="h-5 w-5 text-gray-500" />
          </button>
          <div className="flex items-center gap-3">
            <div className="p-2 bg-blue-50 text-blue-600 rounded-lg">
              <Shield className="h-6 w-6" />
            </div>
            <h1 className="text-2xl font-bold text-gray-900">Política de Privacidade</h1>
          </div>
        </div>

        <div className="p-6 md:p-8 prose prose-blue max-w-none text-gray-600">
          <p className="lead text-lg text-gray-700 mb-8">
            A Multiveicular valoriza a privacidade dos seus associados. Esta Política de Privacidade descreve como coletamos, usamos, armazenamos e protegemos suas informações pessoais.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">1. Coleta de Informações</h2>
          <p>
            Coletamos informações que você nos fornece diretamente, como nome, CPF, endereço, e-mail, telefone, além de dados do seu veículo e informações de pagamento quando você se associa à Multiveicular.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">2. Uso das Informações</h2>
          <p>
            Utilizamos suas informações para:
          </p>
          <ul className="list-disc pl-6 space-y-2 mb-6">
            <li>Processar sua associação e gerenciar seu cadastro;</li>
            <li>Fornecer os serviços de proteção automotiva contratados;</li>
            <li>Comunicar sobre sua fatura, novidades e alertas importantes;</li>
            <li>Atender a requisitos legais e regulatórios.</li>
          </ul>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">3. Compartilhamento de Dados</h2>
          <p>
            Não vendemos suas informações pessoais. Podemos compartilhar seus dados com prestadores de serviços terceirizados (como oficinas, serviços de reboque e processadores de pagamento) estritamente necessários para a prestação dos serviços contratados.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">4. Segurança</h2>
          <p>
            Implementamos medidas de segurança técnicas e organizacionais para proteger suas informações contra acesso, alteração, divulgação ou destruição não autorizada.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">5. Seus Direitos</h2>
          <p>
            Você tem o direito de solicitar acesso, correção ou exclusão dos seus dados pessoais armazenados em nosso sistema, de acordo com a Lei Geral de Proteção de Dados (LGPD).
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">6. Contato</h2>
          <p>
            Se tiver dúvidas sobre esta Política de Privacidade, entre em contato conosco através dos nossos canais oficiais de atendimento.
          </p>
          
          <div className="mt-12 pt-6 border-t border-gray-100 text-sm text-gray-400 text-center">
            Última atualização: {new Date().toLocaleDateString('pt-BR')}
          </div>
        </div>
      </div>
    </div>
  );
}
